import { HeadCell } from 'components/ui/EnhancedTable';
import useAxios from 'library/axios'; 
import { useState } from 'react';
import { IStore,  IStoreSearch } from "../models/Store";
import { useTranslation  } from 'react-i18next';
import { ITextFilterElement } from 'components/ui/BasicTextFilterForm';
import { useNavigate } from 'react-router-dom';


const _ = () => {

    const axios = useAxios();     

    const createStore = async (store: IStore)  =>       
        await (await axios.post('/api/configuration/store/create', store)).data;       
        
    const updateStore = async (store: IStore)  =>       
        await (await axios.post('/api/configuration/store/update', store)).data; 
    
    const getStore = async (id  : number )  => {
      const {data} = (await axios.get(`/api/configuration/store/get-store/${id}`));
      return await data;
    }

    const getStores = async (criteria: IStoreSearch) : Promise<IStore[]> => {
    const {name, description, location} = criteria;

    const {data} = (await axios.get(`/api/configuration/store/get-stores?name=${name}&description=${description}&location=${location}`));
      return await data;
    }

    
      
    return {    
      createStore,
      updateStore,

      getStore,
      getStores,

    } 
}

export default _;


export const useBasicFilterStore = ( onRowDoubleClick: (event: React.MouseEvent<unknown>, row: IStore) => void  ) => {

  const { getStores } = _();

  const { t, i18n } = useTranslation();   
  const navigate = useNavigate();

  

  const [headStoreCells, setHeadStoreCells]  = useState<HeadCell<IStore>[]>([
    {id:'name', label : t('Name'),  display: true, type: 'string', },
    {id:'description', label : t('Description'),  display: true, type: 'string', },
    {id:'location', label : t('Location'),  display: true, type: 'string', },

    {id:'isShowroom', label : `${t('Showroom')} ? `,  display: true, type: 'string', },
  ]); 

  const [filterElements, ] = useState([       
        {name: 'name', text: t('Name'), value: ''}, 
        {name: 'description', text: t('Description'), value: ''},
        {name: 'location', text: t('Location'), value: ''},
      ]);

  const [filteredStores, ] = useState<IStore[]>([]); 

  const onFilterButtonClick = async (filterElements: ITextFilterElement[]): Promise<IStore[]> => {
            
    const name = filterElements.find( elt => elt.name === 'name')?.value || '';
    const description = filterElements.find( elt => elt.name === 'description')?.value || '';
    const location = filterElements.find( elt => elt.name === 'location')?.value || '';

    const arr = await getStores( {name, description, location} );
    
    return arr;
  }

  const objKey: keyof IStore = 'id';

  return {
    title: t('List of stores'), headCells: headStoreCells, objKey,
    filterElements, rows: filteredStores, 
    onFilterButtonClick, onRowDoubleClick
  }
}

